import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY } from 'app/business-logic/services/query-key';
import { fetchWeatherProcessSchemaProcessVariables } from 'app/business-logic/services/process-schema-services';
import Guid from 'core/types/Guid';

export const useWeatherProcessSchemaProcessVariables = ({
  monitorIds,
  timeBetween,
}: {
  monitorIds: Guid[];
  timeBetween: {
    startTime: string;
    endTime: string;
  };
}) => {
  const { data, isLoading, isFetching } = useQuery({
    queryKey: [QUERY_KEY.weatherProcessSchemaProcessVariables, monitorIds, timeBetween],
    queryFn: () => fetchWeatherProcessSchemaProcessVariables({ monitorIds, timeBetween }),
    enabled: monitorIds.length > 0 && !!timeBetween.startTime && !!timeBetween.endTime,
  });
  return {
    data,
    isLoading,
    isFetching,
  };
};
